import { snakelize, camelize } from '../../../helpers/object';
import {
  GetBaseGuidelineRulesRequestParams,
  GetGuidelineRulesRequestParams,
  GetGuidelineRulesResponse,
} from './guidelineRules.types';

export default (
  $axios: any,
): {
  getGuidelineRules: (
    data?: GetGuidelineRulesRequestParams,
  ) => Promise<GetGuidelineRulesResponse>;
  getBaseGuidelineRules: (
    data?: GetBaseGuidelineRulesRequestParams,
  ) => Promise<GetGuidelineRulesResponse>;
  index: any;
  create: any;
  store: any;
  updatesAmbassadorRules: any;
  uploadImage: any;
} => ({
  /**
   * 가이드라인 목록 조회 API
   */
  async getGuidelineRules(
    data?: GetGuidelineRulesRequestParams,
  ): Promise<GetGuidelineRulesResponse> {
    return camelize(
      await $axios.get(`/guideline-rules`, snakelize({ params: data })),
    );
  },

  /**
   * 베이스 가이드라인룰 목록 조회 API
   */
  async getBaseGuidelineRules(
    data?: GetBaseGuidelineRulesRequestParams,
  ): Promise<GetGuidelineRulesResponse> {
    return camelize(
      await $axios.get(`/product/rules/create`, snakelize({ params: data })),
    );
  },

  /**
   * 가이드라인룰 목록 조회
   * @deprecated
   */
  async index(data?: any) {
    return camelize(
      await $axios.get(`/guideline-rules`, snakelize({ params: data })),
    );
  },

  /**
   * 베이스 가이드라인룰 생성
   * @deprecated
   */
  async create(data?: any) {
    return camelize(
      await $axios.get(`/product/rules/create`, snakelize({ params: data })),
    );
  },

  async store(data?: any) {
    return camelize(await $axios.post('/guideline-rules', snakelize(data)));
  },

  async updatesAmbassadorRules(data?: any) {
    return camelize(
      await $axios.post(
        '/guideline-rules/updates-ambassador-rules',
        snakelize(data),
      ),
    );
  },

  //  가이드 이미지 업로드
  async uploadImage(data?: any) {
    const formData = new FormData();
    formData.append('image', data.image);
    formData.append('brand_token', data.brandToken);
    return camelize(
      await $axios.post('/guideline-rules/image/upload', formData),
    );
  },

  // async delete(data?: any) {
  //   return camelize(await $axios.delete(`/guide/${data.id}`))
  // },
});
